import React from "react"
import {Box, Typography} from "@mui/material"
import {getMerkmal} from "../../misc/widget-functions"
import Icons from "../../assets/Icons"

const LeistungsmerkmalWidget = ({widget, value}) => {
    const merkmal = getMerkmal(widget)
    const question = merkmal?.question ?? widget.text
    const longName = merkmal?.longName
    const isIncluded = Boolean(value)
    const iconName = isIncluded ? "checked-outlined" : "minus-outlined"
    const iconColor = isIncluded ? "#0446BE" : "#B91C1C"

    return (
        <Box
            display="flex"
            alignItems="center"
            width="100%"
            justifyContent={longName ? "space-between" : "flex-start"}>
            <Box
                display="flex"
                alignItems="center"
                gap={1}>
                <Box sx={{ flexShrink: 0, display: 'flex' }}>
                    {Icons(iconColor)[iconName]}
                </Box>
                <Typography>{question}</Typography>
            </Box>
            {longName && (
                <Typography fontWeight="700">{longName}</Typography>
            )}
        </Box>
    )
}

export default LeistungsmerkmalWidget
